var _mask, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_515_1027",
    maskUnits: "userSpaceOnUse",
    x: 6.25,
    y: 2.75,
    width: 9,
    height: 14,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 6.25,
    y: 2.75,
    width: 9,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6679 9.29289C14.0584 9.68342 14.0584 10.3166 13.6679 10.7071L8.5625 15.8125C8.32087 16.0541 7.92912 16.0541 7.6875 15.8125C7.44588 15.5709 7.44588 15.1791 7.6875 14.9375L12.625 10L7.6875 5.0625C7.44588 4.82088 7.44588 4.42912 7.6875 4.1875C7.92912 3.94588 8.32088 3.94588 8.5625 4.1875L13.6679 9.29289Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6679 9.29289C14.0584 9.68342 14.0584 10.3166 13.6679 10.7071L8.5625 15.8125C8.32087 16.0541 7.92912 16.0541 7.6875 15.8125C7.44588 15.5709 7.44588 15.1791 7.6875 14.9375L12.625 10L7.6875 5.0625C7.44588 4.82088 7.44588 4.42912 7.6875 4.1875C7.92912 3.94588 8.32088 3.94588 8.5625 4.1875L13.6679 9.29289Z",
    fill: "#5032C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.625 10L12.9786 10.3536L13.3321 10L12.9786 9.64645L12.625 10ZM7.6875 14.9375L8.04105 15.2911L7.6875 14.9375ZM8.5625 15.8125L8.20895 15.4589L8.5625 15.8125ZM13.3143 10.3536L8.20895 15.4589L8.91605 16.1661L14.0214 11.0607L13.3143 10.3536ZM8.04105 15.2911L12.9786 10.3536L12.2714 9.64645L7.33395 14.5839L8.04105 15.2911ZM12.9786 9.64645L8.04105 4.70895L7.33395 5.41605L12.2714 10.3536L12.9786 9.64645ZM8.20895 4.54105L13.3143 9.64645L14.0214 8.93934L8.91605 3.83395L8.20895 4.54105ZM8.04105 4.70895C7.99469 4.66258 7.99469 4.58742 8.04105 4.54105L7.33395 3.83395C6.89706 4.27083 6.89706 4.97917 7.33395 5.41605L8.04105 4.70895ZM8.04105 15.4589C7.99469 15.4126 7.99469 15.3374 8.04105 15.2911L7.33395 14.5839C6.89706 15.0208 6.89706 15.7292 7.33395 16.1661L8.04105 15.4589ZM8.20895 15.4589C8.16258 15.5053 8.08742 15.5053 8.04105 15.4589L7.33395 16.1661C7.77083 16.6029 8.47917 16.6029 8.91605 16.1661L8.20895 15.4589ZM8.04105 4.54105C8.08742 4.49469 8.16258 4.49469 8.20895 4.54105L8.91605 3.83395C8.47917 3.39706 7.77083 3.39706 7.33395 3.83395L8.04105 4.54105ZM14.0214 11.0607C14.6072 10.4749 14.6072 9.52513 14.0214 8.93934L13.3143 9.64645C13.5096 9.84171 13.5096 10.1583 13.3143 10.3536L14.0214 11.0607Z",
    fill: "#5032C8",
    mask: "url(#path-1-outside-1_515_1027)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.984a5e9ee3cdc3b09c14b0d9916cfe9b.svg";
export { ForwardRef as ReactComponent };